import { Lightning } from "@lightningjs/sdk";
import { PlanCard } from "./PlanCard";
/** The selected plan expands while its neighbours contract, keeping a 20px gap. */
export class PlanRow extends Lightning.Component {
    constructor() {
        super(...arguments);
        this._index = 1;
    }
    static _template() {
        return {
            w: PlanCard.W * 2 + PlanCard.EXPANDED_W + 40,
            h: PlanCard.EXPANDED_H,
            Cards: {},
        };
    }
    set items(items) {
        let x = 0;
        this._index = Math.max(0, items.findIndex((item) => item.popular));
        this.tag("Cards").children = items.map((item, index) => {
            const expanded = index === this._index;
            const card = {
                type: PlanCard,
                x,
                item,
                expansion: expanded ? 1 : 0,
            };
            x += (expanded ? PlanCard.EXPANDED_W : PlanCard.W) + 20;
            return card;
        });
        this._refocus();
    }
    _getFocused() {
        return this.tag("Cards").children[this._index];
    }
    _handleLeft() {
        this.select(this._index - 1);
        return true;
    }
    _handleRight() {
        this.select(this._index + 1);
        return true;
    }
    select(index) {
        const cards = this.tag("Cards").children;
        const next = Math.max(0, Math.min(cards.length - 1, index));
        if (next === this._index)
            return;
        this._index = next;
        let x = 0;
        cards.forEach((card, cardIndex) => {
            const expanded = cardIndex === next;
            card.setExpanded(expanded);
            card.setSmooth("x", x, PlanCard.EXPANSION_TRANSITION);
            x += (expanded ? PlanCard.EXPANDED_W : PlanCard.W) + 20;
        });
        this._refocus();
    }
    _handleUp() {
        return true;
    }
    _handleDown() {
        return true;
    }
    _handleEnter() {
        // Checkout is not connected in this demo.
        return true;
    }
}
export default PlanRow;
//# sourceMappingURL=PlanRow.js.map